
  import { Vue, Component, Prop } from "vue-property-decorator";
  import Processing from '@/components/common/Processing.vue';
  import Spinner from '@/components/common/Spinner.vue';

  @Component({
    components: {
      Processing,
      Spinner,
    },
  })
  export default class LoadingOverlay extends Vue {
    @Prop({ type: Boolean, default: false }) readonly hasData!: boolean;
    @Prop({ type: Boolean, required: true }) readonly loading!: boolean;
    @Prop({ type: Boolean, default: false }) readonly spinnerCentered!: boolean;
    @Prop({ type: String, default: "Information is currently unavailable" }) readonly customPlaceholderMessage!: string;
    @Prop({ type: String, default: "my-56" }) readonly marginTop!: string;
    @Prop({ type: String, default: "h-full" }) readonly containerClass!: string;

    get spinnerCenteredStyles(): Object {
      if(this.spinnerCentered) {
        return " w-full items-center";
      } else {
        return this.marginTop;
      }
    }

    get showNoInformation(): boolean {
      return !this.hasData && !this.loading;
    }
  }
